import { INTEGRATION_METRICS } from '../data/integration-metrics-data';

export default function IntegrationMetrics() {
  return (
    <div className="mb-8 mt-12 grid overflow-hidden rounded-[24px] border border-warm-gray-300 bg-white sm:grid-cols-2 lg:grid-cols-4">
      {INTEGRATION_METRICS.map(metric => (
        <div
          key={metric.label}
          className="border-b border-warm-gray-300 p-6 text-left last:border-b-0 lg:border-b-0 lg:border-r lg:last:border-r-0"
        >
          <p className="font-fraunces text-4xl font-semibold leading-[40px] tracking-[-0.9px] text-foreground">
            {metric.value}
          </p>
          <p className="mt-1 text-sm leading-5 text-foreground-secondary">
            {metric.label}
          </p>
        </div>
      ))}
    </div>
  );
}
